import { AssemblyItem } from '@/assembly/api/types';
import { RegisterAssemblyFormData } from '@/assembly/components/register-assembly-dialog';
import { WarningAmberOutlined } from '@/constants/hardfin-standard-icons';
import {
  Chip,
  Grid,
  Paper,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import { Control, Controller } from 'react-hook-form';

interface Props {
  item: AssemblyItem;
  control: Control<RegisterAssemblyFormData>;
  idx: number;
}

export function RegisterAssemblyPartRow({ item, idx, control }: Props) {
  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Grid container gap={2}>
        <Grid item xs={12}>
          <Stack
            direction="row"
            justifyContent="space-between"
            spacing={1}
            alignItems={'center'}
          >
            <Stack>
              <Typography variant="subtitle2">{item.sku}</Typography>
              <Typography variant="body2">{item.name}</Typography>
            </Stack>
            <Chip label={`${item.actualQuantity} units`} />
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <Controller
            name={`partSerials.${idx}.serials`}
            control={control}
            defaultValue={[]}
            render={({ field: { onChange, value } }) => (
              <Grid container gap={1}>
                {[...Array(Math.min(item.actualQuantity || 0, 24))].map(
                  (_, serialIdx) => (
                    <Grid
                      container
                      alignItems="center"
                      key={serialIdx}
                      spacing={2}
                    >
                      <Grid item sm={2}>
                        <Typography variant="body2">
                          Unit {serialIdx + 1}
                        </Typography>
                      </Grid>
                      <Grid item sm={9}>
                        <TextField
                          value={value?.[serialIdx] || ''}
                          onChange={(e) => {
                            const newValue = [...(value || [])];
                            newValue[serialIdx] = e.target.value;
                            onChange(newValue);
                          }}
                          size="small"
                          label={`Serial`}
                          placeholder="Serial"
                          fullWidth
                          sx={{ my: 0.5 }}
                        />
                      </Grid>
                      {value?.[serialIdx] &&
                        value.filter((serial) => serial === value[serialIdx])
                          .length > 1 && (
                          <Grid
                            item
                            sm={1}
                            sx={{ display: 'flex', justifyContent: 'center' }}
                          >
                            <Tooltip
                              arrow
                              title={'This overlaps with another serial'}
                            >
                              <WarningAmberOutlined
                                fontSize="small"
                                color="warning"
                              />
                            </Tooltip>
                          </Grid>
                        )}
                    </Grid>
                  )
                )}
              </Grid>
            )}
          />
        </Grid>
      </Grid>
    </Paper>
  );
}
